<template>
  <div class="homeWrap">
    <div class="top-welcome"  v-if="false">
      你好！欢迎回来
    </div>
    <!-- <div class="data-wrap">
      暂无数据
    </div> -->
    <div class="panel-wrap clearfix">
      <div class="panel recent-data">
        <div class="header">
          <div class="title"><i class="ic ic-jinqishuju"></i>近期数据概况</div>
          <div class="date-picker">
            <el-date-picker
              v-model="dateDuring"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="selectDateDuring"
            >
            </el-date-picker>
            <el-popover
              placement="top-end"
              title="提示"
              width="200"
              trigger="hover"
              content="时间范围选择为空时，默认显示最近一周的数据">
              <i slot="reference" class="el-icon-warning"></i>
            </el-popover>
            
          </div>
        </div>
        <div class="data-list height" v-loading="dataLoading">
          <div class="col col1">
            <div class="line">新增供应商数量：{{homeData.countUserBySup && homeData.countUserBySup.countUser || 0}}家</div>
            <div class="line">新增销售商数量：{{homeData.countUserByDe && homeData.countUserByDe.countUser || 0}}家</div>
            <div class="line">新增商品款数：{{homeData.allCountItem && homeData.allCountItem.countItem || 0}}款</div>
            <div class="line">&nbsp;</div>
            <div class="line">新增锁仓订单数：{{homeData.reserveDataInfo && homeData.reserveDataInfo.totalOrderCount || 0}}笔</div>
            <div class="line">新增锁仓款数：{{homeData.reserveSumItem && homeData.reserveSumItem.totalOrderCount || 0}}款</div>
            <div class="line">新增锁仓件数：{{homeData.reserveDataInfo && homeData.reserveDataInfo.sumReserveQuantity || 0}}件</div>
            <div class="line">新增锁仓总金额：{{homeData.reserveDataInfo && homeData.reserveDataInfo.sumPrice || 0}}元</div>
          </div>
          <div class="col col2">
            <div class="line">新增锁仓转下单订单数：{{homeData.getPurchaseDataInfoByReseverOrder && homeData.getPurchaseDataInfoByReseverOrder.totalOrderCount || 0}}笔</div>
            <div class="line">新增锁仓转下单款数：{{homeData.getPurchaseDataInfoByItemIdReseverOrder && homeData.getPurchaseDataInfoByItemIdReseverOrder.totalOrderCount || 0}}款</div>
            <div class="line">新增锁仓转下单件数：{{homeData.getPurchaseDataInfoByReseverOrder && homeData.getPurchaseDataInfoByReseverOrder.sumOrdePurchaseQuantity || 0}}件</div>
            <div class="line">新增锁仓转下单总金额：{{homeData.getPurchaseDataInfoByReseverOrder && homeData.getPurchaseDataInfoByReseverOrder.sumPrice || 0}}元</div>
            <div class="line">新增直接下单订单数：{{homeData.getPurchaseDataInfoByOrder && homeData.getPurchaseDataInfoByOrder.totalOrderCount || 0}}笔</div>
            <div class="line">新增直接下单款数：{{homeData.getPurchaseDataInfoByItemIdOrder && homeData.getPurchaseDataInfoByItemIdOrder.totalOrderCount || 0}}款</div>
            <div class="line">新增直接下单件数：{{homeData.getPurchaseDataInfoByOrder && homeData.getPurchaseDataInfoByOrder.sumOrdePurchaseQuantity || 0}}件</div>
            <div class="line">新增直接下单总金额：{{homeData.getPurchaseDataInfoByOrder && homeData.getPurchaseDataInfoByOrder.sumPrice || 0}}元</div>
          </div>
          <div class="col col3">
            <div class="line">确认下单收款笔数：{{homeData.confirmPaymentDataInfo && homeData.confirmPaymentDataInfo.countNum || 0}}笔</div>
            <div class="line">确认下单收款总金额：{{homeData.confirmPaymentDataInfo && homeData.confirmPaymentDataInfo.sumConfirmAmount || 0}}元</div>
            <div class="line">确认下单结款笔数：{{homeData.confirmSettlementDataInfo && homeData.confirmSettlementDataInfo.countNum || 0}}笔</div>
            <div class="line">确认下单结款总金额：{{homeData.confirmSettlementDataInfo && homeData.confirmSettlementDataInfo.sumConfirmAmount || 0}}元</div>
          </div>
          <div class="col col4">
            <div class="line">新增清算订单数：{{homeData.launchLqDataInfo && homeData.launchLqDataInfo.totalOrderCount || 0}}笔</div>
            <div class="line">确认清算退货件数：{{homeData.returnQuantity && homeData.returnQuantity.sumReturnQuantity || 0}}件</div>
            <div class="line">确认清算收款笔数：{{homeData.confirmlqPaymentDataInfo && homeData.confirmlqPaymentDataInfo.countNum || 0}}笔</div>
            <div class="line">确认清算收款总金额：{{homeData.confirmlqPaymentDataInfo && homeData.confirmlqPaymentDataInfo.sumConfirmAmount || 0}}元</div>
            <div class="line">确认清算结款笔数：{{homeData.confirmlqSettlementDataInfo && homeData.confirmlqSettlementDataInfo.countNum || 0}}笔</div>
            <div class="line">确认清算结款款总金额：{{homeData.confirmlqSettlementDataInfo && homeData.confirmlqSettlementDataInfo.sumConfirmAmount || 0}}元</div>
            <div class="line">完成清算订单数：{{homeData.finishLqDataInfo && homeData.finishLqDataInfo.totalOrderCount || 0}}笔</div>
          </div>
        </div>
      </div>
      <div class="panel waiting-handle">
        <div class="header">
          <div class="title"><i class="ic ic-daichuli"></i>待处理</div>
        </div>
        <div class="data-list height">
          <div class="waiting-box">
            <i class="ic ic-suocang"></i><span class="box-title">待锁仓确认</span>
            <strong class="number">{{homeData.allLockNum && homeData.allLockNum.totalOrderCount || 0}}</strong>
          </div>
          <div class="waiting-box">
            <i class="ic ic-daishoukuan"></i><span class="box-title">平台待确认收款</span>
            <strong class="number">{{homeData.toBeConfirmedBillCount && homeData.toBeConfirmedBillCount.countNum || 0}}</strong>
          </div>
          <div class="waiting-box">
            <i class="ic ic-daituihuo"></i><span class="box-title">待确认退货</span>
            <strong class="number">{{homeData.allReturnNum && homeData.allReturnNum.countNum || 0}}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="all-data">
      <div class="panel">
        <div class="header">
          <div class="title"><i class="ic ic-leijishuju"></i>累计数据</div>
        </div>
        <div class="data-list">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allCountUserByDe && homeData.allCountUserByDe.countUser || 0}}</strong>家</div>
                <div class="label">销售商总数</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allCountUserBySup && homeData.allCountUserBySup.countUser || 0}}</strong>家</div>
                <div class="label">供应商总数</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.getPaltformServiceFee && homeData.getPaltformServiceFee.platformServiceFee || 0}}</strong>元</div>
                <div class="label">平台累计收取服务费</div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{ homeData.itemCountByOn && homeData.itemCountByOn.countItem || 0}}</strong>款</div>
                <div class="label">在售商品总款数</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.totalStockByItemOn && homeData.totalStockByItemOn.totalStock || 0}}</strong>件</div>
                <div class="label">在售商品总库存</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{ homeData.itemCountByOff && homeData.itemCountByOff.countItem || 0}}</strong>款</div>
                <div class="label">下架商品总款数</div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allReserveDataInfo && homeData.allReserveDataInfo.totalOrderCount || 0}}</strong>笔</div>
                <div class="label">累计锁仓订单总数</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allPurchaseDataInfo && homeData.allPurchaseDataInfo.totalOrderCount || 0 }}</strong>笔</div>
                <div class="label">累计下单订单总数</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allLqDataInfo && homeData.allLqDataInfo.totalOrderCount || 0 }}</strong>笔</div>
                <div class="label">累计清算订单总数</div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allReserveDataInfo && homeData.allReserveDataInfo.sumReserveQuantity || 0}}</strong>件</div>
                <div class="label">累计锁仓商品总数</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allPurchaseDataInfo && homeData.allPurchaseDataInfo.sumOrdePurchaseQuantity || 0 }}</strong>件</div>
                <div class="label">累计下单商品总数</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allLqDataInfoByItemId && homeData.allLqDataInfoByItemId.totalOrderCount || 0 }}</strong>件</div>
                <div class="label">累计完成清算商品数</div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allEstablishQuantity && homeData.allEstablishQuantity.totalEstablish || 0}}</strong>件</div>
                <div class="label">累计已核销数量</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allConfirmPaymentDataInfo && homeData.allConfirmPaymentDataInfo.sumConfirmAmount || 0 }}</strong>元</div>
                <div class="label">平台累计确认收款总金额</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="data-box">
                <div class="value"><strong class="strong">{{homeData.allConfirmSettlementDataInfo && homeData.allConfirmSettlementDataInfo.sumConfirmAmount || 0}}</strong>元</div>
                <div class="label">供应商累计确认结款总金额</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    api,
    ajaxPost
  } from '@/common/request.js'
  export default {
    name: 'homeIndex',
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          disabledDate: (e) => {
            let d = e.getTime()
            let now = new Date().getTime()
            return d > now
          }
        },
        dateDuring: '', // 时间间隔
        startTime: '',  // 开始时间
        endTime: '',    // 结束时间
        dataLoading: true,
        homeData: {  // 首页统计数据
        
        }
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        this.dataLoading = true
        ajaxPost('/dwOrder/getIndexDataInfo', {
          supplierUserId: '',
          startTime: this.startTime,
          endTime: this.endTime
        }).then(res => {
          this.dataLoading = false
          console.log(res)
          if (res.errorCode == 200) {
            this.homeData = res.data
          } else {
            this.$message.error(res.errorMsg || '获取数据失败');
          }
        }).catch(err => {
          console.log(err)
          this.dataLoading = false
        })
      },
      selectDateDuring() {
        console.log(this.dateDuring)
        if (this.dateDuring) {
          this.startTime = this.dateDuring[0]
          this.endTime = this.dateDuring[1]
        } else {
          this.startTime = ''
          this.endTime = ''
        }
        this.getData()
      } 
    }
  }
</script>

<style scoped lang="scss">
.homeWrap {
  padding: 6px 20px 20px;
  .top-welcome {
    height: 200px;
    box-sizing: border-box;
    padding: 80px 0 0 48px;
    font-size:36px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:40px;
    letter-spacing:2px;
    background:#fff url(../../assets/images/pic/home_top_bg.png) no-repeat center right/auto 200px;
  }
  .data-wrap {
    margin-top: 24px;
    padding: 60px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    color: #ccc;
  } 
}
// .panel-wrap {
//   margin-top: 24px;
// }
.panel {
  background: #fff;
  border-radius: 2px;
  &.recent-data {
    float: left;
    width: 78%;
  }
  &.waiting-handle {
    float: right;
    width: 21%;
  }
  .header {
    height: 60px;
    padding: 0 20px;
    font-size: 0;
    border-bottom: 1px solid #e5e5e5;
  }
  .title {
    font-size: 20px;
    line-height: 60px;
    display: inline-block;
    .ic {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-size: cover;
      background-repeat: no-repeat;
      vertical-align: text-top;
      margin-right: 8px;
    }
    .ic-jinqishuju {
      background-image: url('../../assets/images/icon/ic_jinqishuju.png');
    }
    .ic-daichuli {
      background-image: url('../../assets/images/icon/ic_daichuli.png');
    }
    .ic-leijishuju {
      background-image: url('../../assets/images/icon/ic_leijishuju.png');
    }
  }
  .date-picker {
    float: right;
    padding-top: 10px;
    
    .el-icon-warning {
      margin-left: 10px;
      font-size: 16px;
      color:#999;
      cursor: pointer;
    }

  }
  .data-list {
    padding: 20px;
    &.height {
      height: 220px;
    }
    .col {
      width: 25%;
      float: left;
      &.col1 {
        width: 22%;
      }
      &.col2 {
        width: 28%;
      }
      &.col3 {
        width: 25%;
      }
      &.col4 {
        width: 25%;
      }
    }
    .line {
      font-size: 13px;
      line-height: 2.2;
      color: #333;
      cursor: default;
      &:hover {
        font-weight: bold;
        transform: scale(1.02, 1.15);
        color: #409eff;
      }
    }
    .waiting-box {
      margin-bottom: 16px;
      height: 60px;
      border-radius: 4px;
      position: relative;
      line-height: 60px;
      border: 1px solid #e5e5e5;
      padding-left: 10px;
      cursor: default;
      &:hover {
        border-color: #409eff;
      }
      .ic {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-size: cover;
        background-repeat: no-repeat;
        vertical-align: text-top;
        margin-right: 8px;
      }
      .ic-suocang {
        background-image: url('../../assets/images/icon/ic_suocang.png');
      }
      .ic-daishoukuan {
        background-image: url('../../assets/images/icon/ic_daishoukuan.png');
      }
      .ic-daituihuo {
        background-image: url('../../assets/images/icon/ic_daituihuo.png');
      }
      
      .box-title {
        
        font-size: 14px;
        color: #333;
      }
      .number {
        position: absolute;
        top: 0;
        right: 10px;
        font-size: 24px;
        color: #333;
      }
    }
    .data-box {
      margin-bottom: 16px;
      padding: 20px 0;
      text-align: center;
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      &:hover {
        box-shadow: 0 0 20px #f1f1f1;
      }
      .label {
        height: 30px;
        font-size: 14px;
        color: #409eff;
        line-height: 30px;
      }
      .value {
        height: 40px;
        font-size: 13px;
        line-height: 40px;
        color: #333;
        .strong {
          color: #000;
          font-size: 24px;
          margin-right: 4px;
        }
      }
    }
  }
}
.all-data {
  margin-top: 24px;
}


</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue